import { FC, useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";

const RefreshStatus: FC = function () {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  useEffect(() => {
    const refresh = async () => {
      try {
        await queryClient.invalidateQueries({ queryKey: ["user"] });
      } catch (error) {
        console.error("Error refreshing queries:", error);
      } finally {
        navigate("/", { replace: true });
      }
    };
    refresh();
  }, [navigate, queryClient]);

  return null;
};

export default RefreshStatus;
